import * as React from 'react'
import {observer} from 'mobx-react'
import {
  EpikQueryParam,
  EpmsSubscriptionStatus,
  isCreditCardPaymentMethod,
  PaymentMethod,
} from '@raisenow/epik'
import {useStores} from '../../../../lib/MobXProvider'
import {WidgetApi} from '../../../../lib/WidgetApi'
import {WidgetView} from '../../../../lib/WidgetView'
import {IconCard} from '../../../ui/Icons'

///////////////////////////////////////////////////////////////////////////////

export const EpmsSubscriptionInfoPaymentMethodDetails = observer(() => {
  const {api} = useStores<{api: WidgetApi}>()
  const {epmsSubscriptionInfo, epmsPaymentSourceInfo} = api

  if (!epmsSubscriptionInfo || !epmsPaymentSourceInfo) {
    return null
  }

  const isCancelled =
    epmsSubscriptionInfo.status === EpmsSubscriptionStatus.CANCELLED

  if (isCancelled) {
    return null
  }

  let paymentMethod = epmsPaymentSourceInfo.payment_method
  const isCreditCard = isCreditCardPaymentMethod(
    epmsPaymentSourceInfo.payment_method,
  )

  let number = epmsPaymentSourceInfo.metadata?.find(
    (v) =>
      v.type === 'request' && v.group === 'payment_info' && v.name === 'number',
  )?.value

  if (number) {
    number = `* ${number}`
  }

  const expm = epmsPaymentSourceInfo.metadata?.find(
    (v) =>
      v.type === 'request' &&
      v.group === 'payment_info' &&
      v.name === 'expiry_month',
  )?.value
  const expy = epmsPaymentSourceInfo.metadata?.find(
    (v) =>
      v.type === 'request' &&
      v.group === 'payment_info' &&
      v.name === 'expiry_year',
  )?.value

  if (isCreditCard) {
    paymentMethod = PaymentMethod.CREDIT_CARD
  }

  const updatePaymentMethod = () => {
    setTimeout(async () => {
      api.epik.updateCurrentUrl({
        params: {
          [EpikQueryParam.VIEW]: WidgetView.SUBSCRIPTION_PAYMENT_METHOD_UPDATE,
        },
      })
      await api.ui.scrollToTop()
      api.ui.focusWidgetElementBySelector(
        '.update-current-payment-method .payment-methods button',
      )
    })
  }

  return (
    <section className="payment-method-details">
      <div className="header">
        <div className="title">
          <h2 className="text">
            {api.trans(
              'blocks.epms_subscription_info.payment_method_details.title',
            )}
          </h2>
          <span className="icon" role="presentation">
            <IconCard />
          </span>
        </div>
      </div>

      <p className="main">
        <span className="payment-method">
          {api.trans(`payment_methods.${paymentMethod}`)}
          {isCreditCard && number && (
            <>
              {': '}
              <span className="cardno">{number}</span>
            </>
          )}
        </span>
        {isCreditCard && expm && expy && (
          <span className="expm-expy">
            {api.trans(
              'blocks.epms_subscription_info.payment_method_details.valid_until',
            )}
            : {expm}/{expy}
          </span>
        )}
      </p>

      <div className="actions">
        <button type="button" onClick={updatePaymentMethod}>
          <span className="link">
            {api.trans(
              'blocks.epms_subscription_info.payment_method_details.update_payment_method',
            )}
          </span>
        </button>
      </div>
    </section>
  )
})
